import * as React from 'react';
import * as _ from 'lodash';
import { Link } from 'react-router';
import Rodal from 'rodal';
import JWPlayer from '@jwplayer/jwplayer-react';
import YouTube from 'react-youtube';
import getVideoId from 'get-video-id';
export default function () {
    function scopeVideo1() {
        var video = getVideoId(this.props.url);
        return [this.props.isYoutube && video ? React.createElement(YouTube, {
                'videoId': video.id,
                'opts': {
                    playerVars: { autoplay: 1 },
                    width: '100%',
                    height: '100%'
                },
                'className': 'video',
                'key': '8641'
            }) : null];
    }
    return React.createElement('div', { 'className': 'VideoModal' }, this.props.visible ? React.createElement(Rodal, {
        'className': 'video-modal-rodal',
        'height': 480,
        'onClose': () => this.props.close(),
        'visible': this.props.visible,
        'width': 800,
        'duration': 0,
        'key': '336'
    }, !this.props.isYoutube ? React.createElement(JWPlayer, {
        'className': 'video',
        'config': {
            key: JWPLAYER_LICENSE_KEY,
            width: '100%',
            height: '100%',
            cast: {},
            autostart: 'true'
        },
        'playlist': this.getPlaylist(),
        'library': '../../global/vendor/jwplayer-8.30.1/jwplayer.js',
        'key': '546'
    }) : null, scopeVideo1.apply(this, [])) : null);
}